import { SchoolDTO, ISchoolDTO } from './school';
import { IRoleDTO, RoleDTO, RoleEnum } from './role';
import { ITeacherDTO, TeacherDTO } from './teacher';
import { IStudentProfileDTO, StudentDTO, StudentProfile } from './student';
import { FileUpload } from '@models/file';

export enum AccountType {
  LOCAL = 'Local',
  GOOGLE = 'Google',
}

export interface IUserListDTO {
  userId: string;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userRole: RoleEnum;
  userActivatedAt: Date;
  registrationLink?: string;
}

export class UserListDTO implements IUserListDTO {
  userId: string = '';
  userEmail: string = '';
  userFirstName: string = '';
  userLastName: string = '';
  userRole: RoleEnum = null;
  userActivatedAt: Date = null;
  registrationLink?: string = null;
}

export interface IUserDTO {
  id: string;
  email: string;
  activatedAt: string | null;
  fullName: string;
  firstName: string;
  lastName: string;
  profilePicture: string | null;
  accountType: AccountType;
  dateOfTermsAgreement?: string | null;
  dateOfGuardianConsent?: string | null;
  dateOfGuardianPermission?: string | null;
  isEnrolled: boolean;
  school: ISchoolDTO;
  role: IRoleDTO;
  teacher?: ITeacherDTO;
  student?: IStudentProfileDTO;
  avatarImage?: FileUpload;
}

export class UserDTO implements IUserDTO {
  id: string = '';
  email: string = '';
  activatedAt: string | null = null;
  firstName: string = '';
  lastName: string = '';
  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }
  profilePicture: string | null = null;
  dateOfTermsAgreement?: string | null = null;
  dateOfGuardianConsent?: string | null = null;
  dateOfGuardianPermission?: string | null = null;
  isEnrolled: boolean = false;
  accountType: AccountType = AccountType.LOCAL;
  school: ISchoolDTO = new SchoolDTO();
  role: IRoleDTO = new RoleDTO();
  teacher: ITeacherDTO = new TeacherDTO();
  student: IStudentProfileDTO = null;
  avatarImage?: FileUpload;

  constructor(configOverride?: Partial<IUserDTO>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IForgotPasswordRequest {
  email: string;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
  email: string = '';

  constructor(configOverride?: IForgotPasswordRequest) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IResetPasswordRequest {
  newPassword: string;
  confirmPassword: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
  newPassword: string = '';
  confirmPassword: string = '';

  constructor(configOverride?: IResetPasswordRequest) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
  oldPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';

  constructor(configOverride?: IChangePasswordRequest) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IChangeUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  profilePicture: string;
  inviteCode: string;
  school: ISchoolDTO;
  role: IRoleDTO;
  accountType: AccountType;
}

export interface IJoinClassroomRequest {
  inviteCode: string;
}

export class ChangeUserRequest implements IChangeUserRequest {
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  profilePicture: string = '';
  inviteCode: string = '';
  school: ISchoolDTO = new SchoolDTO();
  role: IRoleDTO = new RoleDTO();
  accountType: AccountType;

  constructor(configOverride?: IChangeUserRequest) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IStudentAgreementRequest {
  agreesToTermsAgreement: boolean;
  agreesToGuardianConsent: boolean;
  agreesToGuardianPermission: boolean;
}

export class StudentAgreementRequest implements IStudentAgreementRequest {
  agreesToTermsAgreement: boolean = false;
  agreesToGuardianConsent: boolean = false;
  agreesToGuardianPermission: boolean = false;

  constructor(configOverride?: Partial<IStudentAgreementRequest>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface ITeacherAgreementRequest {
  agreesToTermsAgreement: boolean;
}

export class TeacherAgreementRequest implements ITeacherAgreementRequest {
  agreesToTermsAgreement: boolean = false;

  constructor(configOverride?: Partial<ITeacherAgreementRequest>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
export interface IUserQueryParamsDTO {
  schoolId: string;
  schoolName: string;
  pageSize: number;
  page: number;
  sortBy: string;
  sortDirection: '' | 'asc' | 'ASC' | 'desc' | 'DESC';
  query: string;
}

export class UserQueryParamsDTO implements IUserQueryParamsDTO {
  schoolId: string;
  schoolName: string;
  pageSize: number = 10;
  page: number = 0;
  sortBy: string;
  sortDirection: '' | 'asc' | 'ASC' | 'desc' | 'DESC';
  query: string;
}
